export default "__VITE_ASSET__DHXOpmrb__"